<template>
  <v-container class="content">
    <v-row v-if="getLogoCss" no-gutters v-bind:style="getLogoCss" class="mb-5">
      <a v-if="getHomeUrl" v-bind:href="getHomeUrl" style="display: block; width: 100%; height: 100%;" target="_blank">
      </a>
    </v-row>
    <v-row v-else no-gutters justify="center" align="center" class="login-logo mb-5">
      <LoginLogo></LoginLogo>
    </v-row>

    <v-row v-if="linkError" no-gutters justify="center" align="center" class="text-center mb-5 bg-error">
      {{linkError}}
    </v-row>

    <v-row v-if="errorMessage" no-gutters justify="center" align="center" class="text-center mb-5 bg-error">
      {{errorMessage}}
    </v-row>

    <v-form
      ref="form"
      v-bind:disabled="formDisabled"
      v-on:submit.prevent="login"
      data-cy="uploadLink-auth-form">

      <v-row>
        <v-text-field
          type="password"
          label="password"
          v-model="password"
          v-bind:rules="passwordRules"
          prepend-icon="mdi-lock"
          block
          variant="solo-filled"
          flat
          required
          autocomplete="new-password"
          data-cy="uploadLink-auth-password">

        </v-text-field>
      </v-row>

      <v-row class="mt-5">
        <v-btn
          type="submit"
          v-bind:disabled="formDisabled"
          color="primary"
          block
          variant="flat"
          data-cy="uploadLink-auth-authorize-btn"
        >
          {{$t('routes.accesslink.authorize')}}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { useUploadLinkStore } from '@/stores/UploadLinkStore.js';
import LoginLogo from "../account/components/LoginLogo.vue";
import { useTheme } from 'vuetify';

export default {
  name: "UploadlinkLogin",
  components: {
    LoginLogo,
  },
  data() {
    return {
      linkError: "",
      code: "",

      errorMessage: "",
      password: "",
      passwordRules: [
        v => !!v || this.$t('menus.createUser.passwordRequired'),
      ],
      theme: null,
    };
  },
  mounted() {
    const self = this;
    this.code = this.$route.params.code;
    this.theme = useTheme();

    // Set theme based on branding info
    this.setThemeFromBranding();

    const uploadLinkStore = useUploadLinkStore();
    uploadLinkStore.refreshUploadlinkInfo(this.code)
      .then(function(info) {
        if (!info.needPassword) {
          self.$router.push(`/uploadaccess/${self.code}/view`);
        }
      })
      .catch(function (error) {
        if (error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
        ) {
          // Handled error
          self.linkError = error.response.data.error.message;
        } else {
          // unhandled error
          console.log(error);
          self.linkError = "Error!";
        }
      });
  },
  watch: {
    getBrandingInfo(newValue) {
      if (newValue) {
        this.updateThemeColors(this.getUploadlinkInfo);
      }

      if (newValue && newValue.theme) {
        // Update theme mode
        this.setThemeMode(newValue.theme);
      }
    }
  },
  methods: {
    setThemeFromBranding() {
      if (
        this.getUploadlinkInfo &&
        this.getUploadlinkInfo.brand &&
        this.getUploadlinkInfo.brand.theme
      ) {
        this.setThemeMode(this.getUploadlinkInfo.brand.theme);
      } else {
        this.setThemeMode('dark');
      }

      if (this.getUploadlinkInfo) {
        this.updateThemeColors(this.getUploadlinkInfo);
      }
    },
    setThemeMode(themeName) {
      // Properly set theme name in Vuetify 3
      if (themeName === 'light' || themeName === 'dark') {
        this.theme.change(themeName);
      }
    },
    updateThemeColors(linkInfo) {
      console.log("Link info", linkInfo)
      if (linkInfo && linkInfo.brand && linkInfo.brand.color) {
        this.$vuetify.theme.themes.dark.colors.primary = linkInfo.brand.color;
        this.$vuetify.theme.themes.light.colors.primary = linkInfo.brand.color;

        this.$vuetify.theme.themes.dark.colors['on-list'] = linkInfo.brand.color;
        this.$vuetify.theme.themes.light.colors['on-list'] = linkInfo.brand.color;
      }

      if (linkInfo && linkInfo.brand && linkInfo.brand.backgroundColor) {
        this.$vuetify.theme.themes.dark.colors.background = linkInfo.brand.backgroundColor;
        this.$vuetify.theme.themes.light.colors.background = linkInfo.brand.backgroundColor;
      }

      if (linkInfo && linkInfo.brand && linkInfo.brand.foregroundColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface'] = linkInfo.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['tw-surface'] = linkInfo.brand.foregroundColor;

        this.$vuetify.theme.themes.dark.colors['surface'] = linkInfo.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['surface'] = linkInfo.brand.foregroundColor;
      }

      if (linkInfo && linkInfo.brand && linkInfo.brand.foregroundAccentColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface-accent'] = linkInfo.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['tw-surface-accent'] = linkInfo.brand.foregroundAccentColor;

        this.$vuetify.theme.themes.dark.colors['list'] = linkInfo.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['list'] = linkInfo.brand.foregroundAccentColor;
      }
    },
    async login() {
      const validForm = await this.$refs.form.validate();
      if (!validForm.valid) {
        return;
      }

      const formData = {
        code: this.code,
        password: this.password,
      };

      try {
        const uploadLinkStore = useUploadLinkStore();
        const response = await uploadLinkStore.authorizeUploadlink(formData);
        console.log('response', response);
        console.log('this.$router', this.$router);
        this.$router.push(`/uploadaccess/${this.code}/view`);
      } catch (error) {
        if (error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message) {
          this.errorMessage = error.response.data.error.message;
        } else {
          console.error(error);
        }
      }
    },
  },
  computed: {
    getUploadlinkInfo() {
      const uploadLinkStore = useUploadLinkStore();
      return uploadLinkStore.getUploadlinkInfo;
    },
    getBrandingInfo() {
      if (this.getUploadlinkInfo && this.getUploadlinkInfo.brand) {
        return this.getUploadlinkInfo.brand;
      }

      return null;
    },
    getLogoCss() {
      if (this.getBrandingInfo && this.getBrandingInfo.logoUrl) {
        return {
          width: '150px',
          height: '150px',
          margin: 'auto',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundImage: 'url("'+this.getBrandingInfo.logoUrl+'")',
        };
      }

      return null;
    },
    getHomeUrl() {
      if (!this.getBrandingInfo || !this.getBrandingInfo.alias) {
        return null;
      }

      const homeURL = this.getBrandingInfo.alias;
      if (!/^https?:\/\//gmi.test(homeURL)) {
        return "http://" + homeURL;
      }

      return homeURL;
    },
    formDisabled() {
      return !!this.linkError;
    }
  }
};
</script>

<style>
.content {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
}

.login-logo {
  min-height: 150px;
}
</style>
